import { session } from 'store2'


export default session   


// WEBPACK FOOTER //
// ./src/utils/session.js